import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"],
  _excluded2 = ["Component"],
  _excluded3 = ["isSelected"];
import { SkeletonBrick, Tag } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { Input } from "../../../../../../../../../../components/Input";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var SumInput = function SumInput(_ref) {
  var _ref$inputProps = _ref.inputProps,
    _ref$inputProps$Compo = _ref$inputProps.Component,
    InputComponent = _ref$inputProps$Compo === void 0 ? Input : _ref$inputProps$Compo,
    inputProps = _objectWithoutProperties(_ref$inputProps, _excluded),
    _ref$pricesProps = _ref.pricesProps,
    _ref$pricesProps$Comp = _ref$pricesProps.Component,
    TagComponent = _ref$pricesProps$Comp === void 0 ? Tag : _ref$pricesProps$Comp,
    pricesProps = _objectWithoutProperties(_ref$pricesProps, _excluded2);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "components-SumInput"
  }, /*#__PURE__*/React.createElement(InputComponent, _extends({}, inputProps, {
    postFix: inputProps.value ? inputProps.postFix : undefined
  })), /*#__PURE__*/React.createElement("div", {
    className: cn('tags')
  }, pricesProps.isLoading && new Array(3).fill(null).map(function () {
    return /*#__PURE__*/React.createElement(SkeletonBrick, {
      className: cn('tag--skeleton'),
      height: 44,
      width: 96
    });
  }), !pricesProps.isLoading && pricesProps.props.map(function (_ref2) {
    var isSelected = _ref2.isSelected,
      props = _objectWithoutProperties(_ref2, _excluded3);
    return /*#__PURE__*/React.createElement(TagComponent, _extends({}, props, {
      className: cn('tag', {
        'is-selected': isSelected
      }),
      key: props.children,
      size: "m",
      tagName: "button"
    }), "".concat(props.children, " \u20BD"));
  })));
};